import { merge } from 'lodash';

const defaultArgs = {
  first: 1000
  // orderBy: 'totalLpSaked',
  // orderDirection: 'desc',
};

const defaultAttrs = {
  pid: true,
  lpToken: true,
  allocPoint: true,
  totalLpStaked: true,
  isDualFarming: true,
  rewarder: true,
  dualRewarderToken: true,
  dualRewardPerSecond: true,
  boostToken: true,
  totalBoostStaked: true
};

export default (args = {}, attrs = {}) => ({
  poolInfos: {
    __args: merge({}, defaultArgs, args),
    ...merge({}, defaultAttrs, attrs)
  }
});
